import Api from "../../../api/index";

const _Championship = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {}
};

export default _Championship;
